// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Assets from "../../Assets/Assets";
// import "./Header.css";
// import NotificationCenter from "./NotificationBell";
// import useNotifications from "./useNotifications";
// import { FiCopy } from "react-icons/fi";

// const Header = () => {
//   const [profileImg, setProfileImg] = useState(
//     JSON.parse(localStorage.getItem("doctorData"))?.porfile_img || ""
//   );

//   const navigate = useNavigate();

//   const {
//     notifications,
//     unreadCount,
//     markAsRead,
//     markAllAsRead,
//     handleNotificationClick,
//   } = useNotifications();

//   useEffect(() => {
//     const handleStorageUpdate = () => {
//       const doctorData = JSON.parse(localStorage.getItem("doctorData")) || {};
//       setProfileImg(doctorData.profile_img_url || doctorData.porfile_img || "");
//     };

//     window.addEventListener("doctorProfileUpdated", handleStorageUpdate);
//     return () => window.removeEventListener("doctorProfileUpdated", handleStorageUpdate);
//   }, []);
// const [copied, setCopied] = useState(false);

// const handleCopyBookingLink = async () => {
//   const doctorData = JSON.parse(localStorage.getItem("doctorData") || "{}");
//   const hashId = doctorData?.hash_id;

//   if (!hashId) return;

//   const bookingLink = `https://v3doctor.digidoc.co.in/doctor/${hashId}`;

//   try {
//     await navigator.clipboard.writeText(bookingLink);

//     setCopied(true);

//     setTimeout(() => {
//       setCopied(false);
//     }, 2000);
//   } catch (err) {
//     console.error("Copy failed:", err);
//   }
// };
//   return (
//     <div className="header-main">
//       <div className="header-section">
//         <div className="header-left-sec">
//           <p className="date-txt">
//             {new Date().toLocaleDateString("en-US", {
//               weekday: "long",
//               month:   "long",
//               day:     "numeric",
//               year:    "numeric",
//             })}
//           </p>
//         </div>

//         <div className="header-right-sec">
//          <div className="position-relative d-inline-block">
//   <button
//     className="btn bg-dg c-w d-flex gap-1"
//     onClick={handleCopyBookingLink}
//   >
//     Appointment Link <FiCopy size={18} />
//   </button>

//   {copied && (
//     <div className="copy-tooltip-bottom">
//       Copied!
//     </div>
//   )}
// </div>
//           <NotificationCenter
//             notifications={notifications}
//             unreadCount={unreadCount}
//             onMarkAsRead={markAsRead}
//             onMarkAllRead={markAllAsRead}
//             onNotificationClick={handleNotificationClick}
//           />

//           <img
//             src={profileImg}
//             alt="Profile"
//             className="profile-icon"
//             onClick={() => navigate("/profile")}
//             style={{ cursor: "pointer" }}
//             onError={(e) => { e.target.src = Assets.profile_icon; }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Assets from "../../Assets/Assets";
import "./Header.css";
import NotificationCenter from "./NotificationBell";
import NotificationToast from "./NotificationToast";
import useNotifications from "./useNotifications";
import { FiCopy } from "react-icons/fi";

const Header = () => {
  const [profileImg, setProfileImg] = useState(
    JSON.parse(localStorage.getItem("doctorData"))?.porfile_img || ""
  );

  const navigate = useNavigate();

  const {
    notifications,
    unreadCount,
    toasts,
    dismissToast,
    markAsRead,
    markAllAsRead,
    handleNotificationClick,
  } = useNotifications();

  useEffect(() => {
    const handleStorageUpdate = () => {
      const doctorData = JSON.parse(localStorage.getItem("doctorData")) || {};
      setProfileImg(doctorData.profile_img_url || doctorData.porfile_img || "");
    };

    window.addEventListener("doctorProfileUpdated", handleStorageUpdate);
    return () => window.removeEventListener("doctorProfileUpdated", handleStorageUpdate);
  }, []);

  const [copied, setCopied] = useState(false);

  const handleCopyBookingLink = async () => {
    const doctorData = JSON.parse(localStorage.getItem("doctorData") || "{}");
    const hashId = doctorData?.hash_id;

    if (!hashId) return;

    const bookingLink = `https://v3doctor.digidoc.co.in/doctor/${hashId}`;

    try {
      await navigator.clipboard.writeText(bookingLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  return (
    <div className="header-main">
      <div className="header-section">
        <div className="header-left-sec">
          <p className="date-txt">
            {new Date().toLocaleDateString("en-US", {
              weekday: "long",
              month:   "long",
              day:     "numeric",
              year:    "numeric",
            })}
          </p>
        </div>

        <div className="header-right-sec">
          <div className="position-relative d-inline-block">
            <button
              className="btn bg-dg c-w d-flex gap-1"
              onClick={handleCopyBookingLink}
            >
              Appointment Link <FiCopy size={18} />
            </button>

            {copied && (
              <div className="copy-tooltip-bottom">
                Copied!
              </div>
            )}
          </div>

          <NotificationCenter
            notifications={notifications}
            unreadCount={unreadCount}
            onMarkAsRead={markAsRead}
            onMarkAllRead={markAllAsRead}
            onNotificationClick={handleNotificationClick}
          />

          <img
            src={profileImg}
            alt="Profile"
            className="profile-icon"
            onClick={() => navigate("/profile")}
            style={{ cursor: "pointer" }}
            onError={(e) => { e.target.src = Assets.profile_icon; }}
          />
        </div>
      </div>

      <NotificationToast
        toasts={toasts}
        onDismiss={dismissToast}
        onNotificationClick={handleNotificationClick}
      />
    </div>
  );
};

export default Header;